import * as React from "react";
import { SVGProps } from "react";

// Payment method tile for a static account sale on the Payment Overview.
// Carries its own rounded background, so render it without a wrapper.
const StaticAccountPaymentMethod: React.FC<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="48" height="48" rx="10" fill="#F3F3F3" />
    <path
      d="M11.5962 21.2106C11.0877 21.2106 10.666 20.7889 10.666 20.2804V17.1796C10.666 13.5827 13.5931 10.668 17.1776 10.668H20.2784C20.7869 10.668 21.2087 11.0897 21.2087 11.5982C21.2087 12.1067 20.7869 12.5284 20.2784 12.5284H17.1776C14.6102 12.5284 12.5265 14.6122 12.5265 17.1796V20.2804C12.5265 20.7889 12.1048 21.2106 11.5962 21.2106Z"
      fill="#1A1C1F"
    />
    <path
      d="M36.4024 21.2106C35.8939 21.2106 35.4722 20.7889 35.4722 20.2804V17.1796C35.4722 14.6122 33.3885 12.5284 30.8211 12.5284H27.7203C27.2118 12.5284 26.79 12.1067 26.79 11.5982C26.79 11.0897 27.2118 10.668 27.7203 10.668H30.8211C34.4056 10.668 37.3327 13.5827 37.3327 17.1796V20.2804C37.3327 20.7889 36.911 21.2106 36.4024 21.2106Z"
      fill="#1A1C1F"
    />
    <path
      d="M30.8211 37.3346H28.9606C28.4521 37.3346 28.0304 36.9129 28.0304 36.4044C28.0304 35.8959 28.4521 35.4742 28.9606 35.4742H30.8211C33.3885 35.4742 35.4722 33.3904 35.4722 30.823V28.9625C35.4722 28.454 35.8939 28.0323 36.4024 28.0323C36.911 28.0323 37.3327 28.454 37.3327 28.9625V30.823C37.3327 34.4199 34.4056 37.3346 30.8211 37.3346Z"
      fill="#1A1C1F"
    />
    <path
      d="M20.2784 37.3346H17.1776C13.5931 37.3346 10.666 34.4199 10.666 30.823V27.7222C10.666 27.2137 11.0877 26.792 11.5962 26.792C12.1048 26.792 12.5265 27.2137 12.5265 27.7222V30.823C12.5265 33.3904 14.6102 35.4742 17.1776 35.4742H20.2784C20.7869 35.4742 21.2087 35.8959 21.2087 36.4044C21.2087 36.9129 20.7869 37.3346 20.2784 37.3346Z"
      fill="#1A1C1F"
    />
    <path
      d="M26.48 31.7532H21.5187C18.5172 31.7532 16.8676 30.1036 16.8676 27.1021V20.9005C16.8676 17.899 18.5172 16.2494 21.5187 16.2494H26.48C29.4815 16.2494 31.1311 17.899 31.1311 20.9005V27.1021C31.1311 30.1036 29.4815 31.7532 26.48 31.7532ZM21.5187 18.1098C19.559 18.1098 18.728 18.9408 18.728 20.9005V27.1021C18.728 29.0618 19.559 29.8928 21.5187 29.8928H26.48C28.4397 29.8928 29.2707 29.0618 29.2707 27.1021V20.9005C29.2707 18.9408 28.4397 18.1098 26.48 18.1098H21.5187Z"
      fill="#1A1C1F"
    />
    <path
      d="M32.6815 24.9315H15.3172C14.8087 24.9315 14.3869 24.5098 14.3869 24.0013C14.3869 23.4928 14.8087 23.0711 15.3172 23.0711H32.6815C33.19 23.0711 33.6118 23.4928 33.6118 24.0013C33.6118 24.5098 33.19 24.9315 32.6815 24.9315Z"
      fill="#1A1C1F"
    />
  </svg>
);

export default StaticAccountPaymentMethod;
